<div class="flex flex-col gap-6 min-w-0 overflow-x-auto h-full">
    <div class="flex flex-col gap-1 shrink-0">
        <div class="flex items-center gap-3">
            <p-progress-spinner *ngIf="loading()" strokeWidth="5" [style]="{ width: '25px', height: '25px' }" />
        </div>
        <span class="font-normal text-[14px] leading-[20px] text-[#475467]">Total {{ totalProvider() }}</span>
    </div>
    <div class="flex-1 min-h-0 relative">
        <p-chart type="bar" [data]="chartData()" [options]="chartOptions"></p-chart>
    </div>
</div>
